<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="headline">
        <p>是否添加knews套件</p>
        <img v-show="!c.hideBtn" src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      </div>
      <div class="types">
        <div :class="{'type': true, 'active': type.code == t.code}" v-for="(t, i) in types" :key="i" @click="selectType(t)" v-show="t.title">
          <img class="selector" :src="type.code == t.code ? selectIcons.active : selectIcons.normal" alt="icon">
          <div class="con">
            <img :src="t.code == type.code ? t.icons.active : t.icons.normal" alt="icon">
            <p>{{t.title}}</p>
          </div>
        </div>
      </div>
      <div v-if="type.code==1 || type.code==2" class="notice">
        <img src="@assets/img/kk/voiceNotice.svg" alt="">
        <span v-if="type.code==1">请确认文稿内所有视频为横版</span>
        <span v-if="type.code==2">请确认文稿内所有视频为竖版</span>
      </div>
      <div class="btns">
        <p class="confirm green" @click="confirm()">确定</p>
        <p v-show="!c.hideBtn" class="cancel grey" @click="cancel()">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'kkType',
  data() {
    return {
      c: {},
      show: true,
      selectIcons:{
        normal: require('@assets/img/common/selectIcon.svg'),
        active: require('@assets/img/common/selectIconOn.svg')
      },
      types: [
        {
          icons:{
            normal: require('@assets/img/kk/hen.png'),
            active: require('@assets/img/kk/henSelect.png')
          },
          code: 1,
          title: '横版',
        },
        {
          icons:{
            normal: require('@assets/img/kk/shu.png'),
            active: require('@assets/img/kk/shuSelect.png')
          },
          code: 2,
          title: '竖版'
        },
        {
          icons:{
            normal: require('@assets/img/kk/no.png'),
            active: require('@assets/img/kk/noSelect.png')
          },
          code: 0,
          title: '无套件'
        }
      ],
      type: {}
    }
  },
  methods: {
    async open(r,c) {
      this.c = c
      this.r = r
      const types = await this.getData()
      this.matchTypes(types)
      // this.type = this.types[0]
      this.show = true
    },
    matchTypes(types) {
      types.forEach((i, d) => {
        i.code = i.type
        this.types.forEach(j => {
          if (j.code == i.code) {
            this.$set(j, 'title', i.name)
          }
        })
      })

      this.type = types[0]
    },
    selectType(t) {
      this.type = t
    },
    close() {
      this.show = false
    },
    confirm() {
      this.close()
      setTimeout(() => {
        this.r(`${this.type.code}`)
      }, 50)
    },
    cancel() {
      this.r(999)
      this.close()
    },
    getData() {
      return common.myFetch(apis.kankanList, {})
      .then(r => {
        if (r) {
          return r
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    min-height: 290px;
    width: 490px;
    padding: 20px 30px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    position: relative;
    .headline {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      p {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        // position: absolute;
        // right: 28px;
        // top: 18px;
        cursor: pointer;
      }
    }
    .types {
      display: flex;
      height: 130px;
      width: 100%;
      // padding: 0 50px;
      // justify-content: space-around;
      justify-content: space-between;
      .type {
        width: 130px;
        height: 130px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        .selector {
          width: 16px;
          height: 16px;
        }
        .con {
          width: 78px;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: @sub;
          img {
            margin-bottom: 12px;
          }
        }
      }
      .active {
        border-color: @green;
        .con {
          color: @green;
        }
      }
    }
    .notice {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 490px;
      height: 36px;
      background: #FFF4D0;
      border: 1px solid #F0C129;
      border-left: none;
      border-right: none;
      box-sizing: border-box;
      margin: 20px 0 0;
      margin-left: -30px;
      padding: 0 30px;

      img {
        margin-right: 10px;
      }

      span {
        font-size: 14px;
        color: #E7B615;
        font-weight: bold;
      }
    }
    .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      // margin-right: 20px;
      cursor: pointer;
      &.grey {
        background: #B9C3C3;
        color: #FFF;
        border: 1px solid #B9C3C3;
        box-sizing: border-box;
      }
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }
</style>
